import { browser } from '../../services/browser';
import * as call from '../../../modules/call';
import './media-device-picker.scss';
export class MediaDevicePickerController {
    /* @ngInject */
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
        this.showCameraOptions = false;
        this.showAudioOptions = false;
    }
    get shouldShowCameraOptions() {
        return this.showFullOptions && this.cameras.length > 1;
    }
    get shouldShowAudioOptions() {
        return this.showFullOptions && this.microphones.length > 1;
    }
    get isMenuHidden() {
        return !this.showCameraOptions && !this.showAudioOptions;
    }
    changeAudio(deviceId) {
        this.$ngRedux.dispatch(call.actions.changeMic(deviceId));
    }
    changeCamera(deviceId) {
        this.$ngRedux.dispatch(call.actions.changeCamera(deviceId));
    }
    hideMenu(event) {
        // Some devices somehow mess up touch events
        if (browser.isHandheld() && event.type === 'touchstart') {
            return;
        }
        this.showCameraOptions = false;
        this.showAudioOptions = false;
    }
}
